/* ===== Подключение компонентов React ===== */
import { useCallback, useEffect, useLayoutEffect, useRef, useState } from "react";

/* ===== Подключение стилей ===== */
import s from "./PriorityNav.module.scss";


function PriorityNav({ items, variant = "header" }) {

  const isFooter = variant === "footer";

  const wrapRef = useRef(null);
  const measureRef = useRef(null);

  const [visibleCount, setVisibleCount] = useState(items.length);
  const [moreOpen, setMoreOpen] = useState(false);

  const recalc = useCallback(() => {

    {/* ✅ в футере ничего не считаем */}
    if (isFooter) {
      setVisibleCount(items.length);
      setMoreOpen(false);
      return;
    }

    const wrap = wrapRef.current;
    const measure = measureRef.current;
    if (!wrap || !measure) return;

    const wrapW = wrap.clientWidth;

    const li = Array.from(measure.children);
    const widths = li.map((el) => Math.ceil(el.scrollWidth));

    const moreW = widths[widths.length - 1] || 0;

    let used = 0;
    let count = 0;

    for (let i = 0; i < items.length; i++) {
      const w = widths[i] || 0;
      const needMore = i < items.length - 1;
      const reserve = needMore ? moreW : 0;

      if (used + w + reserve <= wrapW) {
        used += w;
        count++;
      } else {
        break;
      }
    }


    setVisibleCount(count);
    if (count === items.length) setMoreOpen(false);
  }, [items.length]);

  // 1) первичный расчёт + когда меняется items
  useLayoutEffect(() => {
    recalc();
  }, [recalc]);

  // 2) ResizeObserver (основной)
  useEffect(() => {
    if (isFooter) return; {/* ✅ в футере не нужно */}
    const wrap = wrapRef.current;
    if (!wrap) return;

    const ro = new ResizeObserver(() => {
      requestAnimationFrame(recalc);
    });

    ro.observe(wrap);
    return () => ro.disconnect();
  }, [recalc]);

  // 3) Fallback: window resize (в некоторых режимах DevTools реально спасает)
  useEffect(() => {
    const onResize = () => requestAnimationFrame(recalc);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [recalc]);

  // закрытие по клику вне
  useEffect(() => {
    const onDoc = (e) => {
      if (!wrapRef.current?.contains(e.target)) setMoreOpen(false);
    };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  const visible = items.slice(0, visibleCount);
  const hidden = items.slice(visibleCount);

  return (
    <>
      <nav
       className={`${s.navWrap} ${isFooter ? s.footer : s.header}`}
       ref={wrapRef}
       >
        <ul className={s.nav}>
          {visible.map((item) => (
            <li key={item.id} className={s.li}>
              <a className={s.link} href={item.href}>{item.label}</a>
            </li>
          ))}

          {/* ✅ “…” показываем только в header режиме */}
          {!isFooter && hidden.length > 0 && (
            <li className={`${s.li} ${s.more}`}>
              <button
                type="button"
                className={s.moreBtn}
                onClick={() => setMoreOpen(v => !v)}
                aria-expanded={moreOpen}
              >
                …
              </button>

              {moreOpen && (
                <div className={s.dropdown}>
                  {hidden.map((item) => (
                    <a key={item.id} className={s.dropLink} href={item.href}>
                      {item.label}
                    </a>
                  ))}
                </div>
              )}
            </li>
          )}
        </ul>
      </nav>

      {/* измеритель (НЕ display:none) */}
      {/* ✅ измеритель нужен только для header */}

      {!isFooter && (
      <ul className={s.measure} ref={measureRef} aria-hidden="true">
        {items.map((item) => (
          <li key={item.id} className={s.li}>
            <a className={s.link} href={item.href}>{item.label}</a>
          </li>
        ))}
        <li className={`${s.li} ${s.more}`}>
          <button type="button" className={s.moreBtn}>…</button>
        </li>
      </ul>
      )}
    </>
  );
}


export default PriorityNav;